<template>
  <v-container class="component_main px-6 py-0">
    <v-row>
      <v-col cols=12>
        <h1>Extrato de glosas</h1>
        <p>Solicite seu extrato de glosas consolidado.</p>
      </v-col>
      <!-- <v-col class="d-flex justify-end" cols="4">
        <v-btn 
          v-if="!userData.PermissaoAcoes.faturamento.includes('getExtratoConsolidado')"
          class="mt-5 ml-4"
          height="31px"
          small
          depressed
          outlined
          color="primary"
          @click="validaForm()"
        >Extrato de lotes consolidados</v-btn>
        <v-tooltip v-else center bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            class="mt-5 ml-4"
            height="31px"
            small
            depressed
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
            >Extrato de lotes consolidados</v-btn>
          </template>
          <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            Você não possui permissão para executar esta ação.
          </span>
        </v-tooltip>
      </v-col> -->
      <v-col cols=12>
       <ExtratoFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :updateFilter="(formData) => solicitaRelatorioConfirm(formData)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :validarForm="validarForm"
          :getOperadoras="(opts) => getOperadoras(opts)"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ExtratoFilter from "@/components/recebiveis/extrato_glosas/Filter";

export default {
  components: {
    ExtratoFilter
  },
  data() {
    return {
      chartId: "1",
      filter:{},
      filteredList: [],
      legendas: {
        apresentado: "Apresentado",
        liberado: "Liberado",
        glosado: "Glosado",
        aconciliar: "À conciliar"
      },
      list:{
        periodo: [],
        grafico:{
          apresentado:  [],
          liberado: [],
          glosado: [],
          aconciliar: []
        }
      },
      prestadores: [],
      validarForm: false
    };
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      userData: (state) => state.userData.userData,
    }),
  },
  beforeUpdate() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
  },
  mounted(){
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
    let opts = {
          grupo_economico: this.grupoEconomico,
          limitar: false,
          modulo_operadora: "recebiveis",
          prestador_ids: []
        }
    this.getOperadoras(opts)
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    solicitaRelatorioConfirm(filter) {
      this.filter = filter
      let prestador = this.filter.prestador_id.length?this.filter.prestador_id.map( prest => this.prestadores.find(p=>p.id == prest).prest_nome).join(', ')+'.' : 'Todos'
      let operadora = this.filter.operadora_ans_id.length?this.filter.operadora_ans_id.map( oper => this.listOperadora.find(p=>p.id == oper).oper_nome).join(', ')+'.' : 'Todos'
      let dataInicial = this.formatDate(this.filter.data_inicio)
      let dataFinal = this.formatDate(this.filter.data_fim)
      let paramModal = {
        type: "info",
        title: "Solicitar extrato de glosas consolidado com o filtro:",
        message: `
          Prestador(es): <strong>${prestador}</strong><br>
          Operadora(s): <strong>${operadora}</strong><br>
          Período de <strong>${dataInicial}</strong> até <strong>${dataFinal}</strong>
          `,
        callback: () => this.solicitaRelatorio(this.filter),
        btConfirm: { name: "Solicitar", show: true },
        btCancel: { name: "Cancelar", show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    solicitaRelatorio(formData) {
      let opts = {}
      if(formData == null){
        opts = Object.assign(this.pagination, { grupoEconomico: this.grupoEconomico, limitar: false }, this.filter)
        this.solicitaRelatorioConfirm(opts).then(()=>this.showList = true)
        return
      }
      formData.grupo_economico = this.grupoEconomico

      let acao ="getExtratoGlosasConsolidado"
      let payload = formData

      var data = {
        query: 
        [{
          "Modulo": "recebiveis",
          "Acao": acao,
          "Payload": payload
        }]
      };

      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: response.warning? "warning":"success",
          title: "Atenção!",
          message: response.mensagem,
          callback: () => {},
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    validaForm(){
      this.validarForm = true
      this.$nextTick(()=>this.validarForm = false)
    }
  }
};
</script>
<style>
</style>